import Image from 'next/image';
import { getContentfulImage } from 'UI/components/Illustration/utils/helpers';
import Svg from 'UI/components/Svg';
import cn from 'classnames';
import LinkWrapper from 'components/Common/LinkWrapper';
import styles from './styles.module.scss';
import { NavItem } from '../NavItem';
import {
  CLIENTS_LIST,
  FEATURED_CASES,
  TEAM,
  TECH_STACK,
} from '../../utils/headerConstants';

const AITransformationMenu = ({ isLightTheme, isPageScrolledDown }) => (
  <div className={cn(styles.dropdownContainer, { [styles.light]: isLightTheme || isPageScrolledDown })}>
    <div className={styles.contentContainer}>
      <div className={styles.leftContent}>
        <p>Our AI Team</p>
        <div className={styles.teamList}>
          {TEAM.map(({ name, image, path }) => (
            <LinkWrapper path={path}>
              <div className={styles.memberContainer}>
                <div className={styles.personImageContainer}>
                  <Image
                    src={getContentfulImage({ src: image, format: 'webp', width: 200 })}
                    width={132}
                    height={132}
                    lazyBoundary="700px"
                    unoptimized
                    loader={(args) => getContentfulImage({ ...args })}
                    className={styles.memberImage}
                  />
                </div>
                <p>{name}</p>
              </div>
            </LinkWrapper>
          ))}
        </div>
        <p>Technolody Stack</p>
        <div className={styles.techList}>
          {TECH_STACK.map((icon) => (
            <div className={styles.techImage}>
              <Svg
                type={icon}
                id={`icon-${icon}`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className={styles.ourWorkContent}>
      <div>
        <p>Our Clients</p>
        <div className={styles.clientsList}>
          {CLIENTS_LIST.map(({ icon, path, title }) => (
            <LinkWrapper
              path={path}
              className={styles.clientImage}
            >
              <div className={styles.clientContainer}>
                <div className={styles.clientIconContainer}>
                  <Svg type={icon} />
                </div>
                <p>{title}</p>
              </div>
            </LinkWrapper>
          ))}
        </div>
        <p>
          Featured Cases
        </p>
        <div>
          <div className={styles.linksContainer}>
            {FEATURED_CASES.map(({ title, path }) => (
              <NavItem
                title={title}
                path={path}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AITransformationMenu;
